import type { Note, UUID } from "@/core/types";

import { NoteListItem } from "./components/NoteListItem";

type Props = {
  notes: Note[] | undefined;
  onToggleNote: (id: UUID) => void;
  onViewNote: (note: Note) => void;
  selectedNoteIds: Set<UUID>;
};

export function NoteList({ notes, onToggleNote, onViewNote, selectedNoteIds }: Props) {
  return (
    <ul className="tw:flex tw:flex-col tw:gap-5">
      {notes?.map((note) => (
        <NoteListItem
          isSelectedForExport={selectedNoteIds.has(note.id)}
          key={note.id}
          note={note}
          onToggleSelection={() => onToggleNote(note.id)}
          onView={() => onViewNote(note)}
        />
      ))}
    </ul>
  );
}
